import { useState } from "react";

export default function CollapseSection({
  title,
  children,
  openDefault = false,
}: {
  title: string;
  children: React.ReactNode;
  openDefault?: boolean;
}) {
  const [open, setOpen] = useState(openDefault);

  return (
    <div
      style={{
        border: "1px solid #e0e0e0",
        borderRadius: "10px",
        marginTop: "1.5rem",
        backgroundColor: "#f9fafb",
        boxShadow: "0 2px 4px rgba(0, 0, 0, 0.05)",
        overflow: "hidden",
        transition: "all 0.3s ease",
      }}
    >
      <div
        onClick={() => setOpen(!open)}
        style={{
          backgroundColor: "#0078d4",
          color: "white",
          padding: "0.9rem 1.2rem",
          cursor: "pointer",
          userSelect: "none",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          fontWeight: "500",
          letterSpacing: "0.3px",
          borderBottom: open ? "1px solid #ddd" : "none",
        }}
      >
        <span>{title}</span>
        <span style={{ fontWeight: "bold", fontSize: "1.2rem" }}>{open ? "−" : "+"}</span>
      </div>

      {/* Body */}
      {open && (
        <div
          style={{
            padding: "1.2rem 1.4rem",
            backgroundColor: "#ffffff",
            color: "#333",
            transition: "max-height 0.3s ease",
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
}
